import { defineMessages } from 'react-intl';

export default defineMessages({
  added: 'Additional path added',
  category: 'Category',
  hint: 'The new parent directory must contain a path to a valid {category}',
  newPath: 'New Path',
  title: 'Add Additional Path'
});
